module.exports = __webpack_public_path__ + "static/media/connected.398dcd29.svg";